import { checkNotBlank, checkIsPercentage,checkContainOnlyNumber } from 'vcomponents/forms/rules/Rules'
import { persistCompanyShorten } from "api/companyform"
import { persistIndividualShorten } from 'api/individuals';

const defaultOpportunityState = () =>{
    var date = new Date();
    date.setDate(date.getDate() + 30);

    return{
        id: null,
        status: null,
        type: "opportunity",
        opportunitySettings:{
            name: null,
            source: null,
            sourceRate: null,
            pipeline : null,
            step: null,
            amount : "0",
            percentage : 0,
            dealine: date,
            mainDocId: null
        },
        company : {
            name: null,
            third: "company",
            type: "prospect",
            legalSettings: {
                capital: null,
                legalFrance: {
                    siret: null,
                    siren: null,
                    vat: null,
                    apeNafCode: null,
                    companyType: null,
                    rcsImmatriculation: null
                }
            }
        },
        contacts:[],
        paramsSettings:{
            owner: null,
            staff: [],
            idCode: null,
            note: "",
        },
        related: {
            staff: [],
            company: []
        }
    }
};

const defaultOpportunityRules = () =>{
    return {
        name: [
            { required: true, message: window.i18n.__("Veuillez renseigner le nom de l'opportunité"), trigger: 'submit' },
            { validator: checkNotBlank, trigger: 'submit' },
        ],
        companyName: [
            { required: true, message: window.i18n.__('Veuillez renseigner le nom de la société'), trigger: 'submit' },
            { validator: checkNotBlank, trigger: 'submit' },
        ],
        percentage: [
            {required: false,  message: window.i18n.__('La valeur doit être située entre 0 et 100'), trigger: 'blur'},
            {validator: checkIsPercentage, trigger: 'blur'},
            {validator: checkContainOnlyNumber, trigger: 'blur'}
        ],
        pipeline: [
            {required: true, message: window.i18n.__('Veuillez sélectionner un pipeline'), trigger: 'submit'}
        ],
        step: [
            {required: true, message: window.i18n.__('Veuillez sélectionner une étape'), trigger: 'submit'}
        ],
        source: [
            {required: true, message: window.i18n.__('Veuillez sélectionner une source'), trigger: 'submit'}
        ],
        sourceRate: [
            {required: true, message: window.i18n.__('Veuillez sélectionner une catégorie de source'), trigger: 'submit'}
        ]
    }

}

const defaultOpportunityListing = () => {
    return{
        sourceRateList : [],
        sourceList : [],
        pipelineList: [],
        stepList : [],
        staffList: [],
        suggestionContactsList: [],
    }
}

const formatContact = (contact) =>{
    let formatedDatas = {
        contactSettings: {
            name : contact.last_name || "",
            forename : contact.first_name || "",
            email : contact.email || "",
            role: contact.position || "",
            id: contact.id
        },
        customfields: contact.customfields || [],
    }
    return formatedDatas;
}

const persistOpportunity = (state) =>{
    let formatDate = state.opportunitySettings.dealine;
    if(typeof state.opportunitySettings.dealine !== "string"){
        formatDate = state.opportunitySettings.dealine.toISOString().split('T')[0]
    }else{
        formatDate = state.opportunitySettings.dealine.split(' ')[0]
    }
    return{
        //main
        name: state.opportunitySettings.name,
        status: state.opportunitySettings.status,
        pipeline: state.opportunitySettings.pipeline?.value || null,
        step: state.opportunitySettings.step?.value || null,
        amount: state.opportunitySettings.amount,
        probability: parseInt(state.opportunitySettings.percentage),
        source: state.opportunitySettings.source?.value || null,
        due_date: formatDate,
        main_doc_id: state.opportunitySettings.mainDocId,
        
        //side params
        number: state.paramsSettings.idCode,
        note: state.paramsSettings.note,
        owner_id: state.paramsSettings.owner,
        assigned_staff_ids: state.paramsSettings.staff,
        
        //company + contacts
        contact_ids: state.related.staff,
        related: state.related.company,
    }
}
const persistThird = (company) => {
    return (company.third === "company") ? persistCompanyShorten(company) : persistIndividualShorten(company);
}
export {
    defaultOpportunityListing,
    defaultOpportunityState,
    defaultOpportunityRules,
    formatContact,
    persistThird,
    persistOpportunity
}